import FavoriteToggle from '@app/components/FavoriteToggle'
import { IComment } from '@app/models/Comment'
import { bindFunctions } from '@app/utils/class'
import { formatDate } from '@app/utils/formatting'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import * as React from 'react'

interface ICommentItemFooterProps {
  item: IComment
  toggleFavorite: (
    feedItemId: string,
    commentId: string,
    userId: string,
    favorite: boolean,
  ) => void
}

type CommentItemFooterProps = ICommentItemFooterProps

export default class CommentItemFooter extends React.PureComponent<
  CommentItemFooterProps
> {
  constructor(props: CommentItemFooterProps) {
    super(props)

    bindFunctions(this)
  }

  public render() {
    return (
      <div className='comment-item-footer'>
        <span className='small'>
          {formatDate(this.props.item.dateCreated, 'MMM D, YYYY h:mm a')}
        </span>
        {this.props.item.isPublic && (
          <span className='ml-2 small text-primary' title='Visible to Public'>
            <FontAwesomeIcon icon={['far', 'lock-open']} fixedWidth />
          </span>
        )}
        <FavoriteToggle
          className='mx-1 px-2'
          hasStarred={this.props.item.hasStarred}
          onToggleFavorite={this._toggleFavorite}
          showCount
        />
      </div>
    )
  }

  private _toggleFavorite(userId: string, isFavorite: boolean) {
    this.props.toggleFavorite(
      this.props.item.parentId,
      this.props.item.id,
      userId,
      isFavorite,
    )
  }
}
